var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85595 15.4553V17.3162C9.85595 18.8928 8.38927 20.167 6.58344 20.167C4.77761 20.167 3.30176 18.8928 3.30176 17.3162V15.4553C3.30176 17.032 4.76844 18.1503 6.58344 18.1503C8.38927 18.1503 9.85595 17.0228 9.85595 15.4553Z",
    stroke: "#151515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85432 12.9342C9.85432 13.3925 9.72599 13.8141 9.50599 14.1808C8.96515 15.07 7.85598 15.6292 6.57264 15.6292C5.28931 15.6292 4.18013 15.0608 3.6393 14.1808C3.4193 13.8141 3.29102 13.3925 3.29102 12.9342C3.29102 12.1458 3.65766 11.44 4.24433 10.9267C4.84016 10.4042 5.65597 10.0925 6.56347 10.0925C7.47097 10.0925 8.28683 10.4133 8.88266 10.9267C9.48766 11.4308 9.85432 12.1458 9.85432 12.9342Z",
    stroke: "#151515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85595 12.9341V15.455C9.85595 17.0316 8.38927 18.15 6.58344 18.15C4.77761 18.15 3.30176 17.0225 3.30176 15.455V12.9341C3.30176 11.3575 4.76844 10.0833 6.58344 10.0833C7.49094 10.0833 8.3068 10.4041 8.90263 10.9175C9.4893 11.4308 9.85595 12.1458 9.85595 12.9341Z",
    stroke: "#151515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1665 10.0558V11.9442C20.1665 12.4484 19.7632 12.8608 19.2499 12.8792H17.4532C16.4632 12.8792 15.5557 12.155 15.4732 11.165C15.4182 10.5875 15.6382 10.0467 16.0232 9.67083C16.3624 9.32249 16.8299 9.12085 17.3432 9.12085H19.2499C19.7632 9.13918 20.1665 9.55164 20.1665 10.0558Z",
    stroke: "#151515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 9.62499V7.79166C1.83301 5.29833 3.33634 3.55666 5.67384 3.26333C5.91218 3.22666 6.15967 3.20833 6.41634 3.20833H14.6663C14.9047 3.20833 15.1338 3.21748 15.3538 3.25415C17.7188 3.52915 19.2497 5.27999 19.2497 7.79166V9.12084H17.343C16.8297 9.12084 16.3622 9.32248 16.023 9.67082C15.638 10.0467 15.418 10.5875 15.473 11.165C15.5555 12.155 16.463 12.8791 17.453 12.8791H19.2497V14.2083C19.2497 16.9583 17.4163 18.7917 14.6663 18.7917H12.3747",
    stroke: "#151515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/wallet-money.8667bc5d014c73d71df02edcb4b0fcc9.svg";
export { ForwardRef as ReactComponent };